module.exports = __webpack_public_path__ + "static/img/texture.2455e08f.png";